import { useCardsRouterContext } from '@apps/card/Card.routes';
import { getDimensions, getOrientation } from '@apps/card/utils';
import { ChoiceGroup, useCustomizationContext } from '@apps/card/routes/CardCustomizer';
import React from 'react';
import { useTemplatesBySize } from './OrientationChoiceGroup';
import { StationeryTemplateCategoryEnum } from '@graphql/generated';
import { useTranslation } from '@shared/core';

export const SizeChoiceGroup = (props: { templateId: string }) => {
  const { templateId } = props;
  const { tq } = useTranslation('stationery');
  const [draft] = useCustomizationContext(draft => draft);
  const category = draft.stationeryTemplateCategory;
  const dimensions = getDimensions(draft.config.card);
  const orientation = getOrientation(dimensions.width, dimensions.height);

  const templates = useTemplatesBySize(category, draft.template.themeId).filter(t => {
    return orientation === getOrientation(t.widthInches, t.heightInches);
  });

  const { goToProductDetailsPage } = useCardsRouterContext();

  if (!templates.length) return null;
  return (
    <ChoiceGroup
      title={tq`Size`}
      value={templateId}
      setValue={nextTemplateId => {
        goToProductDetailsPage('wedding', category, draft.template.themeId, nextTemplateId, 'replace');
      }}
      choices={templates.map(t => t.id)}
      getName={(id: string) => {
        const { widthInches, heightInches } = templates.find(t => t.id === id)!;
        if (category === StationeryTemplateCategoryEnum.napkin) {
          if (widthInches === 4.75) return tq`Cocktail`;
          if (widthInches === 6.5) return tq`Luncheon`;
        }
        return `${widthInches} × ${heightInches} inches`;
      }}
      textTransform="none" // keep "inches" lowercase
      minHeight={55}
    />
  );
};

export const ReadOnlySizeChoiceGroup = () => {
  const { tq } = useTranslation('stationery');
  const [cardDimensions] = useCustomizationContext(draft => getDimensions(draft.config.card));
  const cardSizeText = `${cardDimensions.width} x ${cardDimensions.height} inches`;

  return (
    <ChoiceGroup
      title={tq`Size`}
      value={cardSizeText}
      textTransform="none"
    />
  );
};
